import { render } from "./ArrowDown.vue?vue&type=template&id=3013b294"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"
script.render = render

export default script